import { ICustomField } from '@models/CustomField.model';
import { PRODUCT_TABLE_CUSTOMFIELDS_KEY } from '@pages/Products/components/ListProducts/ConfigProductTable/ConfigProductTable';
import { QueryClient } from 'react-query';
import { IHeadings, linkHeadingChildren, linkHeadings } from './HeadingsCalc';
import { createFromCustomFields } from './createFromCustomFields';
import { ONBORADING_CUSTOM_FIELDS_QUERY_K } from '../OnBoardingModal';

export function prefillCustomFields(
  queryClient: QueryClient,
  initialPages: IHeadings,
) {
  const initClone = new Map(initialPages);
  const prefetched = queryClient.getQueryData<ICustomField[]>(
    PRODUCT_TABLE_CUSTOMFIELDS_KEY,
  );
  const prefetched_new = queryClient.getQueryData<ICustomField[]>(
    ONBORADING_CUSTOM_FIELDS_QUERY_K,
  );
  let dataSource = prefetched_new;
  if (!dataSource) dataSource = prefetched;
  if (!dataSource) return initClone;
  const unlinkedMap = createFromCustomFields(dataSource, initClone);
  if (!unlinkedMap) return initClone;
  const linkedHeadings = linkHeadings(unlinkedMap);
  const linkedChildren = linkHeadingChildren(linkedHeadings);
  return linkedChildren;
}
